import { sendGet, sendDelete, sendPut } from "@/api/base";
import { getAPIData } from "../helpers";
import { UpdateUser, UpdateWorkspace } from "@/api/workspace/types";
import { WidgetCustomisation } from "@/types/workspace";

export const fetchWorkspaceMembers = () => {
  return getAPIData(sendGet(`workspace/members/`));
};

export const fetchWorkspace = () => {
  return getAPIData(sendGet(`workspace/`));
};

export const deleteWorkspaceMember = (user_id: string) => {
  return getAPIData(sendDelete(`workspace/members/remove/${user_id}/`, {}));
};

export const fetchWorkspaceAnalytics = () => {
  return getAPIData(sendGet(`workspace/analytics/`));
};

export const updateWorkspaceUser = (params: UpdateUser) =>
  getAPIData(sendPut("workspace/user/update/", params));

export const updateWorkspace = (params: UpdateWorkspace) =>
  getAPIData(sendPut("workspace/", params));

export const updateWidgetCustomisation = (params: WidgetCustomisation) =>
  getAPIData(sendPut("workspace/widget/", params));
